import { COUPON_OFFERS, REWARD_OFFERING } from "../../constants";
import { getRedeemUrlWithContext } from "../../utils";
import OnboardingPage from "../../common/components/OnboardingPage";
import { RetrieveCoupon } from "../../common/utils/RetrieveCoupon";

function SydneyAirportTacticalMain() {
  const { loading, coupon } = RetrieveCoupon(COUPON_OFFERS.sydneyairporttactical);
  const redeemUrl = getRedeemUrlWithContext("sydney-airport-tactical");

  return (
    <>
      {!loading && (
          <OnboardingPage
            partnerCfg={GLOBAL_CFG["sydney-airport-tactical"]}
            redeemUrl={redeemUrl}
            coupon={coupon}
            rewardId={REWARD_OFFERING.sydneyairporttactical}
          />
      )}
    </>
  );
}

export default SydneyAirportTacticalMain;